var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 149,
    viewBox: "0 0 100 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2644 5.34351L63.0377 3.81679V8.52672L58.4288 7V1.52672L52.2022 0V6.23664H47.5856V0L41.359 1.52672V7L36.7501 8.52672V3.81679L30.5234 5.34351L30.7447 33.3664H69.0431L69.2644 5.34351Z",
    fill: "#868694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8893 37.3438C60.4672 37.3438 69.0423 35.5632 69.0423 33.3667C69.0423 31.1703 60.4672 29.3896 49.8893 29.3896C39.3114 29.3896 30.7363 31.1703 30.7363 33.3667C30.7363 35.5632 39.3114 37.3438 49.8893 37.3438Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 119.305L50.0038 148.183L100 119.305V61.5496L50.0038 32.6641L0 61.5496V119.305Z",
    fill: "url(#paint0_linear_1729_174)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6363 100.049L59.283 106.87H38.7383V104.544C38.7383 103.829 38.7979 103.136 38.9171 102.465C39.0364 101.779 39.1779 101.16 39.3419 100.608C39.5207 100.057 39.7666 99.5051 40.0796 98.9535C40.4075 98.3869 40.713 97.8949 40.9962 97.4775C41.2943 97.06 41.6818 96.6127 42.1587 96.1356C42.6356 95.6436 43.0454 95.241 43.3882 94.928C43.7459 94.6149 44.2154 94.2347 44.7966 93.7874C45.3779 93.3401 45.8473 92.9897 46.205 92.7363C46.5627 92.4828 47.0545 92.1399 47.6805 91.7075C48.3213 91.2752 48.8057 90.9397 49.1336 90.7012C50.6538 89.6128 51.8461 88.5691 52.7105 87.5702C53.5898 86.5713 54.0294 85.5425 54.0294 84.484C54.0294 83.3657 53.7016 82.4414 53.0458 81.7108C52.39 80.9803 51.4362 80.615 50.1843 80.615C48.8728 80.615 47.7997 81.0175 46.9651 81.8226C46.1454 82.6277 45.7505 83.5894 45.7803 84.7076H38.8724C38.8724 81.517 39.9604 78.9004 42.1363 76.8578C44.3272 74.8152 47.0843 73.7939 50.4078 73.7939C51.8088 73.7939 53.1352 74.0176 54.3871 74.4649C55.639 74.8972 56.7494 75.5234 57.7181 76.3434C58.7017 77.1635 59.4842 78.2369 60.0654 79.5639C60.6467 80.8759 60.9373 82.3445 60.9373 83.9696C60.9373 85.3711 60.7733 86.6458 60.4455 87.7938C60.1325 88.9418 59.6481 89.978 58.9924 90.9024C58.3366 91.8119 57.651 92.6021 56.9357 93.273C56.2203 93.9439 55.3261 94.6745 54.253 95.4647C54.0592 95.6138 53.4407 96.0238 52.3975 96.6947C51.3691 97.3507 50.5196 97.9546 49.849 98.5062C49.1932 99.0429 48.7386 99.5573 48.4853 100.049H62.6363Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_174",
    x1: 50,
    y1: 32.6641,
    x2: 50,
    y2: 148.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B7CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel2);
export default __webpack_public_path__ + "static/media/_level-2.1653931cb0fc7c6756d54f43a070453f.svg";
export { ForwardRef as ReactComponent };